import React, {
 useCallback, useEffect, useMemo, useState
} from "react"
import { Link, useParams } from "react-router-dom"
import { FaEye } from "react-icons/fa"

import { getProgramDetail } from "../../requesters/Backend/ProgramRequester"
import OverviewContent from "../Dashboard/OverviewContent"

const PREVIEW_PARTICIPANT_NAME = "Participant"

const previewOverviews = calculators => {
  const published = (calculators || []).filter(calculator => (
    calculator.status === "active"
      && (!calculator.published_date || new Date(calculator.published_date) <= new Date())
  ))

  return Object.values(published.reduce((acc, calculator) => ({
    ...acc,
    [calculator.calculator_type]: {
      calculator_type: calculator.calculator_type,
      version: calculator.version,
      latest_wellbeing: null,
      calculator_results: []
    }
  }), {}))
}

function ProgramPreviewPage({ baseUrl }) {
  const [program, setProgram] = useState(null)
  const [inflight, setInflight] = useState(true)
  const { programId } = useParams()

  const fetchProgram = useCallback(() => {
    getProgramDetail(baseUrl, programId)
      .then(res => {
        setProgram(res.response?.json?.program || null)
        return null
      })
      .catch(() => setProgram(null))
      .finally(() => setInflight(false))
  }, [baseUrl, programId])

  useEffect(() => {
    fetchProgram()
  }, [fetchProgram])

  const overviews = useMemo(() => previewOverviews(program?.calculators), [program])

  const renderCalculatorActions = () => (
    <span className="btn btn-sm btn-main">Start Survey</span>
  )

  const digitalContentAction = (
    <span className="btn btn-main btn-sm text-nowrap ml-md-auto align-self-md-center">Take me There</span>
  )

  if (inflight) {
    return (
      <div className="dashboard-body content">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "calc(100vh - 72px)" }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  if (!program) {
    return (
      <div className="content">
        <div className="container py-5">
          <h1>Program not found</h1>
          <Link className="btn btn-outline-main" to="/backend">Back to Backend</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="program-preview">
      <div className="content">
        <div className="program-preview-bar">
          <span className="program-preview-label">
            <FaEye />
            {`Preview — this is how ${program.name} looks to a participant. Interactions are disabled.`}
          </span>
          <Link className="btn btn-sm btn-outline-main" to={`/backend/programs/${programId}`}>Back to Edit Program</Link>
        </div>
      </div>
      <div className="program-preview-surface">
        <OverviewContent
          firstname={PREVIEW_PARTICIPANT_NAME}
          organisationName={program.organisation_name}
          programName={program.name}
          programHeader={program.header}
          programBody={program.body}
          integrationType={program.integration_type}
          overviews={overviews}
          digitalContentAction={digitalContentAction}
          renderCalculatorActions={renderCalculatorActions} />
      </div>
    </div>
  )
}

export default ProgramPreviewPage
